import {Injectable, DestroyRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RestServiceAbstract} from "../../../core/base/rest.service.abstract";
import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {ResponseModel} from "../../../core/base/response.model";

@Injectable({
  providedIn: 'root'
})

export class DatevIntegrationRestService extends RestServiceAbstract {
  private readonly destroyRef = inject(DestroyRef);
  tokenUrl = `/${this.DATEV}/token`;

  datevUser(idf: any) {
    return this.get(`/${this.DATEV}/datevUser`, {params: {idf: idf}}).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  deactivate(idf: any) {
    return this.get(`/${this.DATEV}/unsubscribe`, {params: {idf: idf}}).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  getDatevToken(code: string, clientId: string | null, idf: string | null) {
    return this.post(this.tokenUrl,
      {
        redirect: this.DATEV_REDIRECT,
        check: sessionStorage.getItem('datev_check'),
        code: code,
        client: clientId,
        idf: idf
      }).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  getDatevDocuments(idf: any) {
    return this.get(`/${this.DATEV}/configuration/getDocumentTypes`, {params: {idf: idf}}).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  getCustomerCongifuration(idf: any) {
    return this.get(`/${this.DATEV}/configuration/customer`, {params: {idf: idf}}).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  getDocTypes() {
    return this.get(`/${this.RESOURCE}/documents/allDocTypes`).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      map((response: ResponseModel) => {
        const found = response.return_object.find(
          (item: any) => item.attribute === 'COLL_INVOICE'
        );
        return found || {attribute: '', value: ''};
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  saveConfiguration(req: any) {
    return this.post(`/${this.DATEV}/configuration/`, req).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  getDatevLogs(idf: any) {
    return this.get(`/${this.DATEV}/notification/latestLogs`, {params: {idf: idf}} ).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }
}
